import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-change-password.hbs';
import Radio from 'backbone.radio';

var alertsCh = Radio.channel('alerts');

var view = Marionette.View.extend(DialogInterface).extend({
    id: 'change-password-dialog',
    template: Handlebars.compile(template),
    ui: {
        current_password: '#current-password',
        new_password: '#new-password',
        confirm_password: '#confirm-password',
        load_spinner: '.loader',
        submit_btn: '.btn.btn-primary',
        form: 'form', 
        password_caps_lock: '.password-caps-lock',
        caps_lock_warningP: 'caps-lock-warningp',
    },
    regions: {
        passwordCapsLock : '@ui.password_caps_lock',
    },
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    events: {
        'submit form': 'onSubmit',
        'keypress @ui.current_password, @ui.new_password, @ui.confirm_password' : 'show_caps_lock_sign',
    },
    onSubmit: function(event) {
        var self = this;
        event.preventDefault();

        // One more validation on submit
        if (!self.passwordMatch()) {
            return;
        }

        this.model.change_password(this.ui.confirm_password.val(), this.ui.current_password.val())
        .then(
            function(resp){
                alertsCh.request('showAlert', {
                    messageType: 'success',
                    message: 'Successfully updated password'
                });
                self.closeDialog();
            },
            function(error){
                switch (error.responseJSON.errors[0].status) {
                    // Bad password
                    case "400":
                        self.showInputError(self.$el.find("#confirm-password"), error.responseJSON.errors[0].detail);
                        self.showInputError(self.$el.find("#new-password"), '');
                        break;
                    // Too short
                    case "401":
                        self.showInputError(self.$el.find("#current-password"), 'Incorrect password');
                        break;
                    default:
                        break;
                }
            });
    },
    onRender: function() {
        _.bindAll(this, 'validateMatch');
        this.ui.submit_btn.prop('disabled', true);
        this.ui.confirm_password.on('keyup', _.debounce(this.validateMatch, 500));
        this.ui.new_password.on('focusout', _.debounce(this.validateMatch, 500));
    },
    validateMatch: function(e) {
        // on enter keypress don't validate again
        if (e.keyCode === 13) {
            return;
        }
        if (this.passwordMatch()){
            this.hideInputError();
            this.ui.submit_btn.prop('disabled', false);
        } else {
            this.showInputError(this.ui.confirm_password, "Passwords do not match");
            this.ui.submit_btn.prop('disabled', true);
        }
    },
    passwordMatch: function() {
        var matched = this.ui.new_password.val() === this.ui.confirm_password.val();
        if (this.ui.new_password.val().length < 1 || this.ui.confirm_password.val().length < 1) {
            matched = false;
        } 
        return matched;
    },
    showInputError: function(target, error) {
        target.siblings('.help-block').text(error);
        target.parent().addClass('has-error');
    },
    hideInputError: function() {
        // remove all errors
        if (this.ui.form.find('.has-error')) {
            this.ui.form.find('.has-error').removeClass('has-error');
        }
        this.ui.form.find('.help-block').text('');
    },
    show_caps_lock_sign: function(e) {
        var s = String.fromCharCode( e.which );
        $(".caps-lock-warningp").hide();
        if ( s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey ) {
            return $(".caps-lock-warningp").show();
        } else {
            return $(".caps-lock-warningp").hide();
        }         
    },
});

export default view;

